<template>
  <Header :title="$t('userManagement.title')" />
  <div class="userManagementContainer">
    <div class="pageContainerJob">
      <!-- Loading Spinner -->
      <div class="customRowTenant">
        <p class="jobHistoryTitle" style="text-align: left">{{ $tenantName }}{{ $t('userManagement.users') }}</p>
        <div class="searchBar">
          <button v-if="search" class="resetButton" @click="resetSearch">×</button>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <circle cx="6.5" cy="7.45996" r="5.75" stroke="#8F969B" stroke-width="1.5" />
            <path d="M11 11.96L15 15.96" stroke="#8F969B" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <input type="text" class="searchInput" :placeholder="$t('common.search')" v-model="search" @input="handleSearch" />
        </div>
      </div>

      <div v-if="loading" style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%">
        <div class="spinner-border text-primary spinner-grow-xl" role="status"></div>
      </div>

      <!-- User Table -->
      <div v-if="!loading" class="">
        <div class="tableHeadingsNew">
          <div class="customRow">
            <div class="tableVr"></div>
            <img src="/backward.svg" :alt="$t('common.back')" style="cursor: pointer" @click="goToPreviousPage" />
            <div class="pageDiv">
              <span class="pageDivText">1/1</span>
            </div>
            <span class="pageOfTitle">{{ $t('common.page') }} {{ page }} {{ $t('common.of') }} {{ totalPages }}</span>
            <img src="/forward.svg" :alt="$t('common.next')" style="cursor: pointer" @click="goToNextPage" />
            <div class="pageDiv">
              <span class="pageDivText">{{ page }} / {{ totalPages }}</span>
            </div>

            <div class="pageDiv" @click.stop="togglePageSizeDropdown">
              <span class="pageDivText">{{ pageSize }}</span>
              <img src="/arrowDownNew.png" class="arrowDownNew" alt="" />

              <ul ref="dropdownEl" v-if="showPageSizeDropdown" class="pageSizeDropdown" @click.stop>
                <li v-for="size in pageSizeOptions" :key="size" @click.stop="selectPageSize(size)">
                  {{ size }}
                </li>
              </ul>
            </div>
          </div>

          <div class="customRow">
            <Filter @filter-applied="handleFilterChange" ref="filterComponent" :initial-active="isActive === true ? $t('common.yes') : isActive === false ? $t('common.no') : ''" :initial-role="selectedRole" />
            <SecondaryButton @click="handleAddUser">{{ $t('userManagement.add_new_user') }}</SecondaryButton>
          </div>
        </div>

        <div class="tableContainer" style="margin-top: 20px">
          <table class="customTable">
            <thead class="customTableHeader">
              <tr class="customTableRow">
                <th>{{ $t('userManagement.table.sr_no') }}</th>
                <th>{{ $t('userManagement.table.first_name') }}</th>
                <th>{{ $t('userManagement.table.last_name') }}</th>
                <th>{{ $t('userManagement.table.email') }}</th>
                <th>{{ $t('userManagement.table.phone') }}</th>
                <th>{{ $t('userManagement.table.is_active') }}</th>
                <th>{{ $t('userManagement.table.actions') }}</th>
              </tr>
            </thead>
            <tbody class="customTableBody">
              <!-- Dynamically create a row for each job -->
              <tr v-for="(user, index) in users" :key="user.id" style="height: 50px !important">
                <td>{{ index + 1 }}</td>
                <td>{{ user.first_name || '-' }}</td>
                <td>{{ user.last_name || '-' }}</td>
                <td>{{ user.email_id }}</td>
                <td>{{ user.phone_number || '-' }}</td>
                <td>
                  <div class="toggle-wrapper">
                    <CustomToggle :modelValue="user.status !== 'Inactive'" @update:modelValue="(value) => handleStatusToggle(user.id, value)" />
                  </div>
                </td>

                <td style="display: flex; flex-direction: row; gap: 13px; justify-content: start; align-items: center; height: 100%; margin-top: 10px">
                  <CustomHyperlink :href="`/edit-user/${user.id}`">{{ $t('userManagement.actions.edit') }}</CustomHyperlink>
                  <CustomHyperlink @click.prevent="handleRoleChange(user.id)">{{ $t('userManagement.actions.change_role') }}</CustomHyperlink>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <!-- <div class="pagination">
            <button @click="prevPage" :disabled="page === 1">Previous</button>
            <span>Page {{ page }} of {{ totalPages }}</span>
            <button @click="nextPage" :disabled="page >= totalPages">Next</button>
          </div> -->
      </div>
    </div>
  </div>

  <!-- Add this confirmation modal -->
  <div v-if="showConfirmModal" class="modal-overlay">
    <div class="confirm-modal">
      <button class="close-button" @click="closeConfirmModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4.16504 4.16602L15.8309 15.8319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4.1642 15.8319L15.8301 4.16602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div class="modal-content">
        <div class="modal-content-inner">
          <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
            <path d="M24.9434 51.313L17.9292 55.3601C21.9764 60.1566 27.5725 63.3881 33.7499 64.4959V56.3987C30.4065 55.5343 27.3619 53.775 24.9434 51.3099V51.313ZM56.8127 32.9147L63.8205 28.8677C65.9494 34.7701 65.9494 41.2307 63.8205 47.133L56.8127 43.0892C57.7309 39.7586 57.7297 36.2416 56.8095 32.9115L56.8127 32.9147ZM59.0705 20.6407L52.0532 24.6877C49.6352 22.2243 46.5918 20.4661 43.2499 19.602V11.5049C49.4272 12.6127 55.0233 15.8442 59.0705 20.6407ZM43.2499 64.4959C49.4272 63.3881 55.0233 60.1566 59.0705 55.3601L52.0564 51.313C49.6375 53.777 46.5929 55.5352 43.2499 56.3987V64.4959Z" stroke="#7AC4EB" stroke-width="2" stroke-linejoin="round" />
            <path d="M16.6658 45.0941C15.1681 40.4838 15.1681 35.5177 16.6658 30.9074M21.4379 22.6392C24.6819 19.0369 28.9829 16.5539 33.7246 15.5459" stroke="#7AC4EB" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
        <h2 class="modal-title">{{ $t('userManagement.modal.confirm_title') }}</h2>
        <p class="modal-message">{{ $t('userManagement.modal.confirm_message') }}</p>

        <div class="modal-buttons">
          <button class="cancel-button" @click="closeConfirmModal">{{ $t('common.cancel') }}</button>
          <button class="confirm-button" @click="confirmStatusChange">{{ $t('common.yes') }}</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Add this new modal for role change -->
  <div v-if="showRoleModal" class="modal-overlay">
    <div class="role-modal">
      <button class="close-button" @click="closeRoleModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4.16504 4.16602L15.8309 15.8319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4.1642 15.8319L15.8301 4.16602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div class="modal-content">
        <div class="modal-body-header">
          <span class="modal-title-new">{{ $t('userManagement.modal.change_roles_title') }}</span>
          <p class="modal-message-new">{{ $t('userManagement.modal.change_roles_message') }}</p>
        </div>

        <div class="roles-container">
          <div v-for="role in roles" :key="role.id" class="role-option" @click="selectedRole = role.id">
            <svg v-if="selectedRole === role.id" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
              <path d="M13 24.3857C6.7275 24.3857 1.625 19.2832 1.625 13.0107C1.625 6.73824 6.7275 1.63574 13 1.63574C19.2725 1.63574 24.375 6.73824 24.375 13.0107C24.375 19.2832 19.2725 24.3857 13 24.3857ZM13 3.26074C7.62125 3.26074 3.25 7.63199 3.25 13.0107C3.25 18.3895 7.62125 22.7607 13 22.7607C18.3787 22.7607 22.75 18.3895 22.75 13.0107C22.75 7.63199 18.3787 3.26074 13 3.26074Z" fill="var(--primary-color)" />
              <path d="M13 19.5107C16.5899 19.5107 19.5 16.6006 19.5 13.0107C19.5 9.42089 16.5899 6.51074 13 6.51074C9.41015 6.51074 6.5 9.42089 6.5 13.0107C6.5 16.6006 9.41015 19.5107 13 19.5107Z" fill="var(--primary-color)" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
              <path d="M13 24.3857C6.7275 24.3857 1.625 19.2832 1.625 13.0107C1.625 6.73824 6.7275 1.63574 13 1.63574C19.2725 1.63574 24.375 6.73824 24.375 13.0107C24.375 19.2832 19.2725 24.3857 13 24.3857ZM13 3.26074C7.62125 3.26074 3.25 7.63199 3.25 13.0107C3.25 18.3895 7.62125 22.7607 13 22.7607C18.3787 22.7607 22.75 18.3895 22.75 13.0107C22.75 7.63199 18.3787 3.26074 13 3.26074Z" fill="var(--primary-color)" />
            </svg>
            <span>{{ role.roleName }}</span>
          </div>
        </div>

        <div class="modal-buttons">
          <button class="cancel-button" @click="closeRoleModal">{{ $t('common.cancel') }}</button>
          <button class="confirm-button" @click="confirmRoleChange">{{ $t('userManagement.modal.done') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import { get, put } from '../../utils/api.js'
import CustomToggle from '../../components/CustomToggle/CustomToggle.vue'
import CustomHyperlink from '../../components/CustomHyperlink/CustomHyperlink.vue'
import Filter from '../../components/Filter/Filter.vue'
import SecondaryButton from '../../components/SecondaryButton/SecondaryButton.vue'
import { showToast } from '@/utils/toast'

export default {
  components: {
    Header,
    CustomToggle,
    CustomHyperlink,
    Filter,
    SecondaryButton,
  },
  data() {
    return {
      roles: [],
      tenants: [],
      loading: false,
      users: [],
      selectedTenantId: '',
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 1,
      pageSizeOptions: [10, 20, 50, 100],
      showPageSizeDropdown: false,
      search: '',
      isActive: null,
      debounceTimeout: null,
      showConfirmModal: false,
      pendingStatusChange: null,
      showRoleModal: false,
      selectedRole: null,
      selectedUserId: null,
      tenantName: '',
    }
  },
  mounted() {
    // Get tenant ID and name from route params
    this.selectedTenantId = this.$route.params.id
    this.tenantName = decodeURIComponent(this.$route.params.tenantName)
    document.title = `${this.tenantName} - Users`
    this.fetchUsers()
    this.fetchRoles()
    document.addEventListener('click', this.handleClickAway)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickAway)
  },
  methods: {
    handleClickAway(event) {
      const dropdownEl = this.$refs.dropdownEl
      if (dropdownEl && !dropdownEl.contains(event.target)) {
        this.showPageSizeDropdown = false
        this.showEditCategoryDropdown = false
      }
    },
    togglePageSizeDropdown() {
      this.showPageSizeDropdown = !this.showPageSizeDropdown
    },
    async fetchRoles() {
      this.loading = true
      try {
        const res = await get('/v1/roles')
        if (res?.data?.code === 200) {
          this.roles = res.data.data.roles?.filter((role) => role.roleName !== 'SYSTEM ROLE') || []
        }
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    async fetchTenants() {
      this.loading = true
      try {
        const res = await get('/v1/tenants?page=1&pageSize=10')
        if (res?.data?.code === 200) {
          this.tenants = (res.data.data.tenants || []).map((tenant) => ({
            label: tenant.tenant_name,
            value: tenant.id,
          }))
        }
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    async selectPageSize(size) {
      this.pageSize = size
      this.page = 1
      this.showPageSizeDropdown = false
      await this.fetchUsers()
    },
    async fetchUsers() {
      try {
        this.loading = true
        // Always include tenantId from route params
        let url = `/v1/users?page=${this.page}&pageSize=${this.pageSize}&tenantId=${this.selectedTenantId}`

        if (this.search) {
          url += `&search=${encodeURIComponent(this.search)}`
        }
        if (this.isActive !== null) {
          url += `&isActive=${this.isActive}`
        }

        const response = await get(url)
        if (response?.data?.code === 200) {
          const data = response.data.data
          this.users = response.data.data.users || []
          this.total = data.total
          this.totalPages = Math.ceil(this.total / this.pageSize)
        } else {
          this.users = []
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    formatDate(dateStr) {
      const dateObj = new Date(dateStr)
      return dateObj.toLocaleDateString()
    },
    prevPage() {
      if (this.page > 1) {
        this.page--
        this.fetchUsers()
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++
        this.fetchUsers()
      }
    },
    handleAddUser() {
      const tenantName = localStorage.getItem('url_name')
      this.$router.push(`/${tenantName}/create-user`)
    },

    async goToPreviousPage() {
      if (this.page > 1) {
        this.page--
        await this.fetchUsers()
      }
    },
    async goToNextPage() {
      if (this.page < this.totalPages) {
        this.page++
        await this.fetchUsers()
      }
    },
    async updatePageSize(event) {
      this.pageSize = parseInt(event.target.value)
      this.page = 1 // reset to first page
      await this.fetchUsers()
    },
    handleSearch() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.fetchUsers()
      }, 300)
    },
    handleFilterChange(filters) {
      this.isActive = filters.active === 'Yes' ? true : filters.active === 'No' ? false : null
      this.selectedRole = filters.role
      this.page = 1
      this.fetchUsers()
    },
    resetSearch() {
      this.search = ''
      this.fetchUsers()
    },
    resetAllFilters() {
      this.search = ''
      this.selectedTenantId = ''
      this.isActive = null
      this.selectedRole = null
      if (this.$refs.filterComponent) {
        this.$refs.filterComponent.resetFilters()
      }
      this.page = 1
      this.fetchUsers()
    },
    async updateUserStatus(userId, value) {
      try {
        const response = await put(`/v1/users/${userId}`, {
          status: value ? 'Active' : 'Inactive',
          is_active: value,
          first_name: this.users.find((u) => u.id === userId)?.first_name || null,
          last_name: this.users.find((u) => u.id === userId)?.last_name || null,
          phone_number: this.users.find((u) => u.id === userId)?.phone_number || null,
          tenant_id: this.selectedTenantId, // Use the tenant ID from route
          email_id: this.users.find((u) => u.id === userId)?.email_id || null,
        })

        if (response?.data?.code === 200) {
          const currentUser = this.users.find((u) => u.id === userId)
          if (currentUser) {
            currentUser.status = value ? 'Active' : 'Inactive'
          }
          showToast({
            title: 'Operation Successful',
            message: `User ${value ? 'enabled' : 'disabled'} successfully`,
            type: 'success',
          })
        }
      } catch (error) {
        showToast({
          title: 'Operation Failed',
          message: 'Failed to update user status',
          type: 'error',
        })
      }
    },
    handleStatusToggle(userId, value) {
      this.pendingStatusChange = { userId, value }
      this.showConfirmModal = true
    },
    closeConfirmModal() {
      this.showConfirmModal = false
      this.pendingStatusChange = null
    },
    async confirmStatusChange() {
      if (this.pendingStatusChange) {
        const { userId, value } = this.pendingStatusChange
        await this.updateUserStatus(userId, value)
        this.closeConfirmModal()
      }
    },
    async handleRoleChange(userId) {
      try {
        // First fetch the current user role
        const response = await get(`/v1/user-roles/${userId}`)

        if (response?.data?.code === 200 && response.data.data.length > 0) {
          // Set the current role as selected
          this.selectedRole = response.data.data[0].roleId
        }

        this.selectedUserId = userId
        this.showRoleModal = true
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'Failed to fetch user role',
          type: 'error',
        })
      }
    },
    closeRoleModal() {
      this.showRoleModal = false
      this.selectedRole = null
      this.selectedUserId = null
    },
    async confirmRoleChange() {
      if (!this.selectedRole || !this.selectedUserId) return

      try {
        const response = await put(`/v1/user-roles/update`, {
          userId: this.selectedUserId,
          roleIds: [this.selectedRole],
        })

        if (response?.data?.code === 200) {
          showToast({
            title: 'Success',
            message: 'User role updated successfully',
            type: 'success',
          })
          this.closeRoleModal()
          this.fetchUsers()
        }
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'Failed to update user role',
          type: 'error',
        })
      }
    },
  },
  watch: {
    selectedTenantId(newValue) {
      // Reset to first page when tenant changes
      this.page = 1
      this.fetchUsers()
    },
  },
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.pagination button {
  padding: 5px 10px;
  cursor: pointer;
}

.pageDiv {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  background: #fff;
}

.resetButton {
  position: absolute;
  right: 30px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #8f969b;
}

.searchBar {
  position: relative;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirm-modal {
  display: flex;
  width: 405px;
  height: 282px;
  padding: 24px 40px 23px 40px;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  position: relative;
}

.close-button {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 14px;
  top: 14px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.modal-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.modal-title {
  color: var(--primary-color);
  text-align: left;
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 8px;
}

.modal-title-new {
  color: var(--primary-color);
  text-align: left;
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 8px;
  width: 100%;
}

.modal-message {
  overflow: hidden;
  color: #667085;
  text-overflow: ellipsis;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  /* 178.571% */
}

.modal-message-new {
  color: #667085;
  text-overflow: ellipsis;
  font-family: Archivo;
  text-align: left;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  /* 178.571% */
  width: 100%;
}

.modal-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.modal-buttons button {
  width: 123.915px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: Archivo;
  font-weight: 500;
}

.cancel-button {
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
}

.confirm-button {
  background: var(--primary-color);
  border: none;
  color: white;
}

.modal-content-inner {
  display: flex;
  width: 100px;
  height: 100px;
  padding: var(--Micro-XL, 12px);
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background-color: #f0f9fd;
  border-radius: 50%;
}

.role-modal {
  display: flex;
  width: 405px;
  height: 322px;
  padding: 24px 24px 23px 24px;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  position: relative;
}

.roles-container {
  width: 100%;
  margin: 20px 0;
}

.role-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  cursor: pointer;
}

.role-option span {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 16px;
  font-weight: 500;
}

.modal-body-header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: -20px;
}
</style>
